module.exports = __webpack_public_path__ + "media/svg/lc-46ec9f4c.svg";